// Written into .env.production by build.sh, so a deployed bundle can be tied back to
// a commit and its age read without looking anything up. Local builds have neither.
export const GIT_COMMIT = process.env.REACT_APP_GIT_COMMIT || null
export const BUILT_AT = process.env.REACT_APP_BUILT_AT || null

// Support needs the version of a kiosk or admin session without going through New
// Relic: the attributes show up on <html> in the elements inspector, the global is
// there for the console. Nothing is published for an unversioned local build.
export const publishBuildInfo = () => {
  if (!GIT_COMMIT && !BUILT_AT) return

  window.__BUILD__ = { gitCommit: GIT_COMMIT, builtAt: BUILT_AT }
  if (GIT_COMMIT) document.documentElement.setAttribute('data-git-commit', GIT_COMMIT)
  if (BUILT_AT) document.documentElement.setAttribute('data-built-at', BUILT_AT)
}
